
export default function Rodape({versao}){
        
  return(
    <footer className='md:flex grid-cols-1 md:grid-cols-2 p-4 items-center justify-between border-t border-secondary border-opacity-50'>
      <div className="left text-center md:text-left md:mb-0 mb-3">
        <p className='text-sm'>Gerenciamento da Qualidade Funcional do Fluido - GQFF</p>
        <p className='md:text-sm'>Versão <strong>{versao}</strong></p>
      </div>

      <div className="right text-center md:text-right">
        <p className='md:text-sm'>Desenvolvido por <strong>ASCII Soluções</strong></p>
        <p className='text-sm'>2025 - &copy; Todos os Direitos Reservados</p>
      </div>
    </footer>
  )
}
